/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Finish_To_Profile_ButtonInputs */

const en_register_onboarding_finish_to_profile_button = /** @type {(inputs: Register_Onboarding_Finish_To_Profile_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to profile`)
};

const de_register_onboarding_finish_to_profile_button = /** @type {(inputs: Register_Onboarding_Finish_To_Profile_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Profil`)
};

/**
* | output |
* | --- |
* | "Go to profile" |
*
* @param {Register_Onboarding_Finish_To_Profile_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_finish_to_profile_button = /** @type {((inputs?: Register_Onboarding_Finish_To_Profile_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Finish_To_Profile_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_finish_to_profile_button(inputs)
	return en_register_onboarding_finish_to_profile_button(inputs)
});